import ComponentModule from "@eisinc/Overrides/Components/ProductCarouselProduct";

export * from "@eisinc/Overrides/Components/ProductCarouselProduct";

export default ComponentModule;
